import gql from 'graphql-tag';

import { FEEDBOARD_RESPONSE_FRAGMENT } from '../fragments/Board/feedBoardResponse';

export const GET_FEED_BOARDS_QUERY = gql`
  query GetFeedBoards(
    $cursor: Int
    $plexIds: [String!]!
    $filterPublishStatus: FilterPublishStatus!
    $labelIds: [String!]!
  ) {
    loggedIn {
      feedBoards(cursor: $cursor, plexIds: $plexIds) {
        nextCursor
        items {
          ...feedBoardResponse
        }
      }
    }
  }

  ${FEEDBOARD_RESPONSE_FRAGMENT}
`;
